module.exports = __webpack_public_path__ + "static/logo-reel-bw-cefa0d0fde8a2cdcd59aa864f55e867a.jpg";